const styles = {
  background: {
    minHeight: '100vh',
    background: 'gainsboro',
    padding: '20px',
    boxSizing: 'border-box'
  } as React.CSSProperties
}

export default styles;